const CONTADO = '01'
const CREDITO = '02'
const LETRAS = '03'

const __dictionary = {
  [CONTADO]: {
    id: CONTADO,
    nombre: 'CONTADO'
  },
  [CREDITO]: {
    id: CREDITO,
    nombre: 'CRÉDITO'
  },
  [LETRAS]: {
    id: LETRAS,
    nombre: 'LETRAS'
  }
}

const __array = [__dictionary[CONTADO], __dictionary[CREDITO], __dictionary[LETRAS]]

export default Object.freeze({
  CONTADO,
  CREDITO,
  LETRAS,
  __dictionary,
  __array
})
